import {Component} from '@angular/core';
import {InvoiceFranchiseComponent} from "../components/invoice-franchise.component";
import {InvoiceEntryComponent} from "../components/invoice-entry.component";
import {InvoiceCustomComponent} from "../components/invoice-custom.component";
import {InvoiceType} from "../interfaces";
import {InvoiceTypePipe} from "../pipes/invoice-type.pipe";

@Component({
    selector: 'app-invoice',
    imports: [InvoiceFranchiseComponent, InvoiceEntryComponent, InvoiceCustomComponent, InvoiceTypePipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-file-invoice me-2"></i>Rechnungen</h3>
                </div>

                <ul class="nav nav-tabs mb-3">
                    <li class="nav-item" (click)="setTab($event, 'franchise')">
                        <a class="nav-link" [class.active]="currentTab == 'franchise'" href>{{ 'franchise' | invoiceType }}</a>
                    </li>
                    <li class="nav-item" (click)="setTab($event, 'recurring')">
                        <a class="nav-link" [class.active]="currentTab == 'recurring'" href>{{ 'recurring' | invoiceType }}</a>
                    </li>
                    <li class="nav-item" (click)="setTab($event, 'entry')">
                        <a class="nav-link" [class.active]="currentTab == 'entry'" href>{{ 'entry' | invoiceType }}</a>
                    </li>
                    <li class="nav-item" (click)="setTab($event, 'various')">
                        <a class="nav-link" [class.active]="currentTab == 'various'" href>{{ 'various' | invoiceType }}</a>
                    </li>
                    <li class="nav-item" (click)="setTab($event, 'credit')">
                        <a class="nav-link" [class.active]="currentTab == 'credit'" href>{{ 'credit' | invoiceType }}</a>
                    </li>
                </ul>

                @if (currentTab == 'franchise') {
                    <app-invoice-franchise/>
                } @else if (currentTab == 'recurring') {
                    <app-invoice-custom [invoiceType]="InvoiceType.RECURRING"/>
                } @else if (currentTab == 'entry') {
                    <app-invoice-entry/>
                } @else if (currentTab == 'various'){
                    <app-invoice-custom [invoiceType]="InvoiceType.VARIOUS"/>
                } @else if (currentTab == 'credit'){
                    <app-invoice-custom [invoiceType]="InvoiceType.CREDIT"/>
                }
            </div>
        </div>
    `
})
export class InvoiceComponent {

    currentTab = 'franchise';

    setTab(event: any, tab: string): void {
        event.preventDefault();

        this.currentTab = tab;
    }

    protected readonly InvoiceType = InvoiceType;
}
